export const environment: any = {
  production: true,
  enableDebug: true,
  isDebugMode: "true",
  oem: "iveco",
  defaultLangCode: "en_US",
  defaultLangName: "English",
  cookieName: "myAppLocaleCookie",
  instrumentationKey: "88ea5c65-6114-47d1-9040-d426a5533328"
};